<div class="page">

  <!-- ── Page Header ── -->
  <div class="page-header">
    <div>
      <h1>Notifications</h1>
      <p>Send push notifications to users and track history</p>
    </div>
    <button class="btn-primary" (click)="openPanel()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
      </svg>
      Send Notification
    </button>
  </div>

  <!-- ── Success Toast ── -->
  <div class="toast-success" *ngIf="sendSuccess">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
    {{ sendSuccess }}
  </div>

  <!-- ── Loading ── -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-lg"></div>
    <p>Loading notifications...</p>
  </div>

  <!-- ── Table ── -->
  <div class="table-card" *ngIf="!isLoading">

    <!-- Count row -->
    <div class="table-meta" *ngIf="total > 0">
      Showing {{ rangeStart }}–{{ rangeEnd }} of {{ total }} notifications
    </div>

    <table class="notif-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Title</th>
          <th>Body</th>
          <th>Type</th>
          <th>Audience</th>
          <th>Sent At</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let n of notifications">
          <td class="td-id">{{ n.id }}</td>

          <td class="td-title">
            <div class="bilingual-cell">
              <span class="cell-en">{{ n.title_en || '—' }}</span>
              <span class="cell-ar" dir="rtl" *ngIf="n.title_ar">{{ n.title_ar }}</span>
            </div>
          </td>

          <td class="td-body">
            <div class="bilingual-cell">
              <span class="cell-en">{{ n.body_en || '—' }}</span>
              <span class="cell-ar" dir="rtl" *ngIf="n.body_ar">{{ n.body_ar }}</span>
            </div>
          </td>

          <td>
            <span class="type-badge" [ngClass]="typeClass(n.type)">{{ n.type }}</span>
            <span class="cat-note" *ngIf="n.category">{{ n.category }}</span>
          </td>

          <td>
            <span class="audience-badge" [ngClass]="audienceBadgeClass(n.target?.audience)">
              {{ audienceLabel(n) }}
            </span>
          </td>

          <td class="td-date">{{ formatDate(n.created_at) }}</td>
        </tr>

        <tr *ngIf="notifications.length === 0">
          <td colspan="6" class="empty-row">No notifications sent yet.</td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="pagination-row" *ngIf="totalPages > 1">
      <button class="page-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">‹</button>
      <ng-container *ngFor="let p of pageNumbers">
        <span *ngIf="p === -1" class="page-gap">…</span>
        <button *ngIf="p !== -1" class="page-btn" [class.active]="p === currentPage" (click)="goToPage(p)">
          {{ p }}
        </button>
      </ng-container>
      <button class="page-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">›</button>
    </div>
  </div>

</div>

<!-- ══════════════════════════════════════════════════════════ -->
<!-- ── Compose Slide-in Panel ── -->
<!-- ══════════════════════════════════════════════════════════ -->
<div class="panel-backdrop" *ngIf="showPanel" (click)="closePanel()"></div>

<div class="compose-panel" [class.open]="showPanel">

  <div class="panel-header">
    <div>
      <h2>Send Notification</h2>
      <p>Compose and target your push notification</p>
    </div>
    <button class="btn-close-panel" (click)="closePanel()" [disabled]="isSending">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <div class="panel-body">

    <!-- Error -->
    <div class="error-msg" *ngIf="sendError">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ sendError }}
    </div>

    <!-- ── Title ── -->
    <div class="panel-section">
      <h3 class="panel-section-title">Title</h3>
      <div class="field-row">
        <div class="field-group">
          <label>English</label>
          <input type="text" [(ngModel)]="form.title_en" name="title_en" placeholder="e.g. New Update" />
        </div>
        <div class="field-group">
          <label>Arabic</label>
          <input type="text" [(ngModel)]="form.title_ar" name="title_ar" placeholder="مثال: تحديث جديد" dir="rtl" />
        </div>
      </div>
    </div>

    <!-- ── Body ── -->
    <div class="panel-section">
      <h3 class="panel-section-title">Body</h3>
      <div class="field-row">
        <div class="field-group">
          <label>English</label>
          <textarea [(ngModel)]="form.body_en" name="body_en" rows="2"
            placeholder="e.g. Check out the latest properties!"
            (keydown)="onBodyKeydown('body_en', $event)"
            (input)="onBodyInput('body_en')"></textarea>
          <div class="body-line-hint" [class.at-limit]="bodyLineCount('body_en') >= 2">
            {{ bodyLineCount('body_en') }} / 2 lines
          </div>
        </div>
        <div class="field-group">
          <label>Arabic</label>
          <textarea [(ngModel)]="form.body_ar" name="body_ar" rows="2"
            placeholder="تفقد أحدث العقارات!" dir="rtl"
            (keydown)="onBodyKeydown('body_ar', $event)"
            (input)="onBodyInput('body_ar')"></textarea>
          <div class="body-line-hint" [class.at-limit]="bodyLineCount('body_ar') >= 2">
            {{ bodyLineCount('body_ar') }} / 2 lines
          </div>
        </div>
      </div>
    </div>

    <!-- ── Type & Entity ── -->
    <div class="panel-section">
      <h3 class="panel-section-title">Notification Type</h3>
      <div class="field-row">
        <div class="field-group">
          <label>Type</label>
          <select [(ngModel)]="form.type" name="type" (ngModelChange)="onReachInputChange()">
            <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>
        <div class="field-group">
          <label>Category <span class="hint">(what users can switch off)</span></label>
          <select [(ngModel)]="form.category" name="category" (ngModelChange)="onReachInputChange()">
            <option *ngFor="let c of categories" [value]="c.value">{{ c.label }}</option>
          </select>
        </div>
        <div class="field-group" *ngIf="form.type !== 'general'">
          <label>Entity ID <span class="hint">(optional)</span></label>
          <input type="number" [(ngModel)]="form.entity_id" name="entity_id"
            placeholder="e.g. 42" min="1" />
        </div>
      </div>
    </div>

    <!-- ── Audience ── -->
    <div class="panel-section">
      <h3 class="panel-section-title">Target Audience</h3>

      <div class="audience-tabs">
        <button *ngFor="let a of audiences"
          type="button"
          class="audience-tab"
          [class.active]="form.audience === a.value"
          (click)="form.audience = a.value; onReachInputChange()">
          {{ a.label }}
        </button>
      </div>

      <!-- registered_between fields -->
      <div class="conditional-fields" *ngIf="form.audience === 'registered_between'">
        <div class="field-row">
          <div class="field-group">
            <label>Registered From <span class="required">*</span></label>
            <input type="date" [(ngModel)]="form.date_from" name="date_from" (ngModelChange)="onReachInputChange()" />
          </div>
          <div class="field-group">
            <label>Registered To <span class="required">*</span></label>
            <input type="date" [(ngModel)]="form.date_to" name="date_to" (ngModelChange)="onReachInputChange()" />
          </div>
        </div>
      </div>

      <!-- user_type fields -->
      <div class="conditional-fields" *ngIf="form.audience === 'user_type'">
        <div class="field-group half">
          <label>User Type <span class="required">*</span></label>
          <select [(ngModel)]="form.user_type" name="user_type" (ngModelChange)="onReachInputChange()">
            <option *ngFor="let ut of userTypes" [value]="ut">{{ ut | titlecase }}</option>
          </select>
        </div>
      </div>

      <!-- single_user fields -->
      <div class="conditional-fields" *ngIf="form.audience === 'single_user'">
        <div class="field-group half">
          <label>User ID <span class="required">*</span></label>
          <input type="number" [(ngModel)]="form.user_id" name="user_id" (ngModelChange)="onReachInputChange()"
            placeholder="e.g. 1" min="1" />
        </div>
      </div>

      <!-- all — no extra fields -->
      <div class="reach-note" *ngIf="reach || reachLoading">
        <ng-container *ngIf="reach && !reachLoading; else reachWait">
          Will reach <strong>{{ reach.will_receive }}</strong> of {{ reach.matched }}
          <span *ngIf="reach.skipped_by_preference > 0"> · {{ reach.skipped_by_preference }} turned this off</span>
          <span *ngIf="reach.without_push_token > 0"> · {{ reach.without_push_token }} have no push token (inbox only)</span>
        </ng-container>
        <ng-template #reachWait>Counting who this reaches…</ng-template>
      </div>

      <div class="all-note" *ngIf="form.audience === 'all'">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/>
          <line x1="12" y1="8" x2="12.01" y2="8"/>
        </svg>
        This notification will be sent to <strong>all registered users</strong>.
      </div>
    </div>

  </div>

  <div class="panel-footer">
    <button class="btn-secondary" (click)="closePanel()" [disabled]="isSending">Cancel</button>
    <button class="btn-primary" (click)="send()" [disabled]="isSending">
      <span *ngIf="!isSending">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="22" y1="2" x2="11" y2="13"/>
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
        Send
      </span>
      <span *ngIf="isSending" class="spinner-sm"></span>
    </button>
  </div>

</div>
